import { Directive, ElementRef } from '@angular/core';
import { DigitOnlyBase } from './digit-only-base';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[dfFloatDigitOnly]'
})
export class FloatDigitOnlyDirective extends DigitOnlyBase {
  regex = /[^(-?\d+)|\.]/gi;

  constructor(protected inputElement: ElementRef) {
    super(inputElement);
  }

  allowKey(e: KeyboardEvent): boolean {
    if (e.key === '-' || e.key === '.') {
      return true;
    }
    if (e.code) {
      if (e.code === 'Minus' || e.code === 'Period') {
        return true;
      }
    }
    return false;
  }
}
